export default "__VITE_ASSET__a2c122e2__"